import store from "@/store/VuexPlugin";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "feature",
  store
})
export class FeatureStore extends VuexModule {
  /**
   * Setting for interactive camera view.
   */
  private _isInteractiveCameraEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isInteractiveCameraEnabled || true;

  /**
   * Get the current value of the interactive camera setting.
   */
  get isInteractiveCameraEnabled(): boolean {
    return this._isInteractiveCameraEnabled;
  }

  /**
   * Dispatches an action to set the interactive camera property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Action
  public setInteractiveCamera(value: boolean) {
    this.context.commit("_mutateInteractiveCamera", value);
  }

  /**
   * Mutates the interactive camera property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Mutation
  private _mutateInteractiveCamera(value: boolean) {
    this._isInteractiveCameraEnabled = value;
  }

  /**
   * Setting for Pagination
   */
  private _isPaginationEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isPaginationEnabled || false;

  /**
   * Get the current value of the Pagination setting.
   */
  get isPaginationEnabled(): boolean {
    return this._isPaginationEnabled;
  }

  /**
   * Dispatches an action to set the Pagination  property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Action
  public setPaginationEnabled(value: boolean) {
    this.context.commit("_mutatePaginationEnabled", value);
  }

  /**
   * Mutates the interactive Pagination property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Mutation
  private _mutatePaginationEnabled(value: boolean) {
    this._isPaginationEnabled = value;
  }

  /**
   * Setting for PaginationUser
   */
  private _isPaginationUserEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isPaginationUserEnabled || false;

  /**
   * Get the current value of the PaginationUser setting.
   */
  get isPaginationUserEnabled(): boolean {
    return this._isPaginationUserEnabled;
  }

  /**
   * Dispatches an action to set the PaginationUser  property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Action
  public setPaginationUserEnabled(value: boolean) {
    this.context.commit("_mutatePaginationUserEnabled", value);
  }

  /**
   * Mutates the interactive PaginationUser property.
   *
   * @param value The value to set the interactiveCamera to.
   */
  @Mutation
  private _mutatePaginationUserEnabled(value: boolean) {
    this._isPaginationUserEnabled = value;
  }

  /**
   * Setting for progressStatusEnabled components.
   */
  private _isUpdateProgressStatusEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isUpdateProgressStatusEnabled || false;

  /**
   * Get the current value of the progressStatusEnabled setting.
   */
  get isUpdateProgressStatusEnabled(): boolean {
    return this._isUpdateProgressStatusEnabled;
  }

  /**
   * Dispatches an action to set the progress status enabled property.
   *
   * @param value The value to set the progressStatusEnabled to.
   */
  @Action
  setUpdateProgressStatusEnabled(value: boolean) {
    this.context.commit("updateProgressStatus", value);
  }

  /**
   * Mutates the progress status enabled property.
   *
   * @param value The value to set the progressStatusEnabled to.
   */
  @Mutation
  updateProgressStatus(value: boolean) {
    this._isUpdateProgressStatusEnabled = value;
  }

  /**
   * Setting to disable or enable settings tab.
   */
  private _isPartnerManagerEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isPartnerManagerEnabled || false;
  /**
   * True if settings control is enabled
   */
  get isPartnerManagerEnabled(): boolean {
    return this._isPartnerManagerEnabled;
  }

  /**
   * Dispatches an action to enable or disable the partner settings control.
   *
   * @param value true to enable partner settings control.
   */
  @Action
  public setIsPartnerManagerEnabled(value: boolean) {
    this.context.commit("_mutateIsPartnerManagerEnabled", value);
  }

  /**
   * Mutate the partner settings control enablement.
   *
   * @param value The value to partner settings to.
   */
  @Mutation
  private _mutateIsPartnerManagerEnabled(value: boolean) {
    this._isPartnerManagerEnabled = value;
  }

  /**
   * Setting for reportAdvertismentEnabled.
   */
  private _isReportAdvertisementEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isReportAdvertisementEnabled || false;

  /**
   * Get the current value of the reportAdvertismentEnabled setting.
   */
  get isReportAdvertisementEnabled(): boolean {
    return this._isReportAdvertisementEnabled;
  }

  /**
   * Dispatches an action to set the report advetisement enabled property.
   *
   * @param value
   */
  @Action
  setReportAdvertisementEnabled(value: boolean) {
    this.context.commit("updateReportAdvertisementEnabled", value);
  }

  /**
   * Mutates the report advetisement enabled property.
   *
   * @param value
   */
  @Mutation
  updateReportAdvertisementEnabled(value: boolean) {
    this._isReportAdvertisementEnabled = value;
  }

  /**
   * Setting for isInviteFriendsEnabled.
   */
  private _isInviteFriendsEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isInviteFriendsEnabled || true;

  /**
   * Get the current value of the isInviteFriendsEnabled setting.
   */
  get isInviteFriendsEnabled(): boolean {
    return this._isInviteFriendsEnabled;
  }

  /**
   * Dispatches an action to set the invite friends enabled property.
   *
   * @param value
   */
  @Action
  setInviteFriendsEnabled(value: boolean) {
    this.context.commit("_updateInviteFriendsEnabled", value);
  }

  /**
   * Mutates the invite friends enabled property.
   *
   * @param value
   */
  @Mutation
  _updateInviteFriendsEnabled(value: boolean) {
    this._isInviteFriendsEnabled = value;
  }

  /**
   * Setting for showing query params in report
   */
  private _isQueryParamsShowing =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isQueryParamsShowing || false;

  /**
   * Get the setting for showing query params in report
   */
  get isQueryParamsShowing(): boolean {
    return this._isQueryParamsShowing;
  }

  /**
   * Dispatches an action to set setting for showing query params in report
   *
   * @param value The value to set the query params to
   */
  @Action
  public setQueryParamsShowing(value: boolean) {
    this.context.commit("_mutateQueryParamsShowing", value);
  }

  /**
   * Mutates the setting for showing query params in report
   *
   * @param value The value to set the query params to
   */
  @Mutation
  private _mutateQueryParamsShowing(value: boolean) {
    this._isQueryParamsShowing = value;
  }

  /**
   * Setting for showing option to export to ksr
   */
  private _isSendToKsrEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isSendToKsrEnabled || false;

  /**
   * Get the current value of the isSendToKsrEnabled
   */
  get isSendToKsrEnabled(): boolean {
    return this._isSendToKsrEnabled;
  }

  /**
   * Dispatches an action to enable the option to export to ksr
   *
   * @param value The value to set the option to.
   */
  @Action
  public setIsSendToKsrEnabled(value: boolean) {
    this.context.commit("_mutateSendToKsrEnabled", value);
  }

  /**
   * Mutates the option to export to ksr
   *
   * @param value The value to set the option to export to ksr.
   */
  @Mutation
  private _mutateSendToKsrEnabled(value: boolean) {
    this._isSendToKsrEnabled = value;
  }

  /**
   * Setting for showing option to export to pdr
   */
  private _isSendToPdrEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isSendToPdrEnabled || false;

  /**
   * Get the current value of the isSendToPdrEnabled
   */
  get isSendToPdrEnabled(): boolean {
    return this._isSendToPdrEnabled;
  }

  /**
   * Dispatches an action to enable the option to export to pdr
   *
   * @param value The value to set the option to.
   */
  @Action
  public setIsSendToPdrEnabled(value: boolean) {
    this.context.commit("_mutateSendToPdrEnabled", value);
  }

  /**
   * Mutates the option to export to pdr
   *
   * @param value The value to set the option to export to pdr.
   */
  @Mutation
  private _mutateSendToPdrEnabled(value: boolean) {
    this._isSendToPdrEnabled = value;
  }

  /**
   * Setting for showing option to export to da
   */
  private _isSendToDaEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isSendToDaEnabled || false;

  /**
   * Get the current value of the isSendToDaEnabled
   */
  get isSendToDaEnabled(): boolean {
    return this._isSendToDaEnabled;
  }

  /**
   * Dispatches an action to enable the option to export to da
   *
   * @param value The value to set the option to.
   */
  @Action
  public setIsSendToDaEnabled(value: boolean) {
    this.context.commit("_mutateSendToDaEnabled", value);
  }

  /**
   * Mutates the option to enable da upload
   *
   * @param value The value to set the option to export to da.
   */
  @Mutation
  private _mutateSendToDaEnabled(value: boolean) {
    this._isSendToDaEnabled = value;
  }

  /**
   * Setting for option to upload pdfs
   */
  private _isPdfUploadEnabled =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isPdfUploadEnabled || true;

  /**
   * Get the current value of the isPdfUploadEnabled
   */
  get isPdfUploadEnabled(): boolean {
    return this._isPdfUploadEnabled;
  }

  /**
   * Dispatches an action to enable the option to export to da
   *
   * @param value The value to set the option to.
   */
  @Action
  public setIsPdfUploadEnabled(value: boolean) {
    this.context.commit("_mutateIsPdfUploadEnabled", value);
  }

  /**
   * Mutates the option to enable pdf upload
   *
   * @param value The value to set the option to enable pdf upload
   */
  @Mutation
  private _mutateIsPdfUploadEnabled(value: boolean) {
    this._isPdfUploadEnabled = value;
  }

  /**
   * Setting for template view.
   */
  private _isTemplateEnabled = JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isTemplateEnabled;

  /**
   * Get the current value of the template setting.
   */
  get isTemplateEnabled(): boolean {
    return this._isTemplateEnabled;
  }

  /**
   * Dispatches an action to set the template property.
   *
   * @param value The value to set the template to.
   */
  @Action
  public setTemplate(value: boolean) {
    this.context.commit("_mutateTemplate", value);
  }

  /**
   * Mutates the template property.
   *
   * @param value The value to set the template to.
   */
  @Mutation
  private _mutateTemplate(value: boolean) {
    this._isTemplateEnabled = value;
  }

  /**
   * Setting for Fleet
   */
  private _fleet: IFleetFeature = JSON.parse(window.localStorage.getItem("feature") || "{}").state?._fleet || {
    isFleetEnabled: true,
    isDriverEnabled: true,
    isPoolEnabled: true,
    isContractEnabled: true,
    isDocumentEnabled: false
  };

  /**
   * Get the current value of the fleet.
   */
  get isFleetFeatureEnabled(): IFleetFeature {
    return this._fleet;
  }

  /**
   * Dispatches an action to set the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Action
  public setFleetEnabled(value: boolean) {
    const features = this.isFleetFeatureEnabled;
    features.isFleetEnabled = value;
    this.context.commit("_mutateFleetFeatureEnabled", features);
  }

  /**
   * Dispatches an action to set the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Action
  public setDriverEnabled(value: boolean) {
    const features = this.isFleetFeatureEnabled;
    features.isDriverEnabled = value;
    this.context.commit("_mutateFleetFeatureEnabled", features);
  }

  /**
   * Dispatches an action to set the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Action
  public setPoolEnabled(value: boolean) {
    const features = this.isFleetFeatureEnabled;
    features.isPoolEnabled = value;
    this.context.commit("_mutateFleetFeatureEnabled", features);
  }

  /**
   * Dispatches an action to set the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Action
  public setContractEnabled(value: boolean) {
    const features = this.isFleetFeatureEnabled;
    features.isContractEnabled = value;
    this.context.commit("_mutateFleetFeatureEnabled", features);
  }

  /**
   * Dispatches an action to set the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Action
  public setDocumentEnabled(value: boolean) {
    const features = this.isFleetFeatureEnabled;
    features.isDocumentEnabled = value;
    this.context.commit("_mutateFleetFeatureEnabled", features);
  }

  /**
   * Mutates the fleet property.
   *
   * @param value The value to set the fleet to.
   */
  @Mutation
  private _mutateFleetFeatureEnabled(value: IFleetFeature) {
    this._fleet = value;
  }

  /**
   * Setting for partner colors
   */
  private _isVuetifyInPartnerColors =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isVuetifyInPartnerColors || false;
  /**
   * Setting for partner colors
   */
  private _isNavigationInPartnerColors =
    JSON.parse(window.localStorage.getItem("feature") || "{}").state?._isNavigationInPartnerColors || false;
  /**
   * Setting for partner colors
   */
  get isVuetifyInPartnerColors() {
    return this._isVuetifyInPartnerColors;
  }
  /**
   * Setting for partner colors
   */
  get isNavigationInPartnerColors() {
    return this._isNavigationInPartnerColors;
  }

  @Mutation
  private _mutateIsVuetifyInPartnerColors(isVuetifyInPartnerColors: boolean) {
    this._isVuetifyInPartnerColors = isVuetifyInPartnerColors;
  }
  @Mutation
  private _mutateIsNavigationInPartnerColors(isNavigationInPartnerColors: boolean) {
    this._isNavigationInPartnerColors = isNavigationInPartnerColors;
  }

  @Action
  public setIsVuetifyInPartnerColors(isVuetifyInPartnerColors: boolean) {
    this.context.commit("_mutateIsVuetifyInPartnerColors", isVuetifyInPartnerColors);
  }
  @Action
  public setIsNavigationInPartnerColors(isNavigationInPartnerColors: boolean) {
    this.context.commit("_mutateIsNavigationInPartnerColors", isNavigationInPartnerColors);
  }
}

export const FeatureModule = getModule(FeatureStore);

export interface IFleetFeature {
  isFleetEnabled: boolean;
  isDriverEnabled: boolean;
  isPoolEnabled: boolean;
  isContractEnabled: boolean;
  isDocumentEnabled: boolean;
}
